import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogInComponent } from '@modules/login/pages/login-page/login.component';
import { authAccessGuard, CreationGuard, homeGuard } from './shared';
import { MainComponent, OverviewTabComponent, CategorySalesTabComponent, ItemsSalesTabComponent } from '@modules/dashboard';
import { HomeComponent } from './home/home.component';
import { LogoutComponent } from './logout/logout.component';

const routes: Routes = [
  {
    path: '', redirectTo: 'login', pathMatch: 'full'
  },
  {
    path: 'login', component: LogInComponent,
    canActivate: [authAccessGuard]
  },
  {
    path: '',
    component: HomeComponent,
    // resolve: { currentClient : CurrentClientResolve },
    canActivate: [homeGuard],
    children: [
      {
        path: 'dashboard', component: MainComponent, children: [
          {
            path: '',
            redirectTo: 'overview',
            pathMatch: 'full'
          },
          { path: 'overview', component: OverviewTabComponent },
          { path: 'category-sales', component: CategorySalesTabComponent },
          { path: 'items-sales', component: ItemsSalesTabComponent }
        ],
      },
      {
        path: 'staff-management',
        loadChildren: () => import('@modules/staff/staff.module').then(mod => mod.StaffModule),
      },
      {
        path: 'sd',
        loadChildren: () => import('@modules/system-design/system-design.routes').then(mod => mod.SYSTEM_DESIGN_ROUTES),
      },
      {
        path: 'loyalty-club',
        loadChildren: () => import('@modules/loyalty-club/customers.module').then(mod => mod.CustomersModule),
      },
      {
        path: 'store-settings',
        loadChildren: () => import('@modules/store/store.module').then(mod => mod.StoreModule),
        // canActivate: [AuthGuardService],
      },
      {
        path: 'sales-reports',
        loadChildren: () => import('@modules/reports/reports.module').then(mod => mod.ReportsModule),
      },
      {
        path: 'account-settings',
        loadChildren: () => import('@modules/settings/account-settings.module').then(mod => mod.AccountSettingsModule),
        // canActivate: [PartnerNotPaidGuardService]
        // canActivate: [AuthGuardService],
      },
      {
        path: 'product-catalog',
        loadChildren: () => import('@modules/product-catalog/product-catalogue.module').then(mod => mod.ProductCatalogueModule),
      },
      {
        path: 'integrations',
        loadChildren: () => import('@modules/integrations/integrations.module').then(mod => mod.IntegrationsModule),
        // canActivate: [AuthGuardService],
      },
        // {
        //   path: 'counter-screen',
        //   loadChildren: () => import('@modules/counter-screen/counter-screen.module').then(mod => mod.CounterScreenModule),
        // },
        {
          path: 'inventory',
          loadChildren: () => import('@modules/inventory/inventory.module').then(mod => mod.InventoryModule),
          // canActivate: [AuthGuardService],
        },
        { path: 'create-menu', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'edit-menu/:id', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'edit-modifier/:id', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'create-modifier', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'edit-modifier-group/:id', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'create-modifier-group', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'edit-product/:id', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'create-product', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'edit-category/:id', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'create-category', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'create-filter', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'edit-filter/:id', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'edit-variant/:id', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        { path: 'create-variant', loadChildren: () => import('@modules/items/create-item.module').then(mod => mod.CreateItemModule), },
        {
          path: 'create-account',
          loadChildren: () => import('@modules/account/create-account.module').then(mod => mod.CreateAccountModule),
          canActivate: [CreationGuard]
        },
        {
          path: 'developers',
          loadChildren: () => import('@modules/developers/developers.module').then(mod => mod.DevelopersModule),
          // canActivate: [AuthGuardService]
        },
        {
          path: 'shopbox-support',
          loadChildren: () => import('@modules/shopbox-support/shopbox-support.module').then(mod => mod.ShopboxSupportModule),
        },
        {
          path: 'dev',
          loadChildren: () => import('@modules/dev/dev.module').then(mod => mod.DevModule),
        },
        {
          path: 'pos-customer-display',
          loadChildren: () => import('@modules/pos-customer-display/pos-customer-display.module').then(mod => mod.PosCustomerDisplayModule),
        }
    ]
  },
  {
    path: 'signup',
    loadChildren: () => import('@modules/sign-up/register.module').then(mod => mod.RegisterModule),
    canActivate: [authAccessGuard]
  },
  {
    path: 'reset',
    loadChildren: () => import('@modules/reset/forgotpassword.module').then(mod => mod.ForgotpasswordModule),
    canActivate: [authAccessGuard]
  },
  {
    path: 'dashboard/staff',
    redirectTo: 'staff-management'
  },
  {
    path: 'staff',
    redirectTo: 'staff-management'
  },
  {
    path: 'dashboard/customers',
    redirectTo: 'loyalty-club'
  },
  {
    path: 'customers',
    redirectTo: 'loyalty-club'
  },
  {
    path: 'dashboard/store',
    redirectTo: 'store-settings'
  },
  {
    path: 'store',
    redirectTo: 'store-settings'
  },
  {
    path: 'dashboard/reports',
    redirectTo: 'sales-reports'
  },
  {
    path: 'reports',
    redirectTo: 'sales-reports'
  },
  {
    path: 'dashboard/accountSettings',
    redirectTo: 'account-settings'
  },
  {
    path: 'accountSettings',
    redirectTo: 'account-settings'
  },
  {
    path: 'dashboard/products',
    redirectTo: 'product-catalog/items'
  },
  {
    path: 'products',
    redirectTo: 'product-catalog/items'
  },
  {
    path: 'product-catalogue/products',
    redirectTo: 'product-catalog/items'
  },
  {
    path: 'product-catalog/products',
    redirectTo: 'product-catalog/items'
  },
  {
    path: 'dashboard/integrations',
    redirectTo: 'integrations'
  },
  {
    path: 'create-company',
    redirectTo: 'create-account'
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: '**', redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, initialNavigation: 'enabledNonBlocking', enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
